import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "printbtn-container" }
const _hoisted_2 = { class: "printbtn" }
const _hoisted_3 = { class: "printbtn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_oio_button = _resolveComponent("oio-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_select, {
        class: "oio-select",
        "dropdown-class-name": "oio-select-dropdown login-oio-select-dropdown",
        value: _ctx.printerValue,
        "show-search": "",
        style: {"width":"180px"},
        onChange: _cache[0] || (_cache[0] = (value) => {_ctx.printerValue = value;_ctx.onSelcetChange();})
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.printerValueOption, (country, index) => {
            return (_openBlock(), _createBlock(_component_a_select_option, {
              key: index,
              title: country.label,
              value: country.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(country.label), 1)
              ]),
              _: 2
            }, 1032, ["title", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_a_select, {
        class: "oio-select",
        "dropdown-class-name": "oio-select-dropdown login-oio-select-dropdown",
        value: _ctx.printerTemp,
        "show-search": "",
        style: {"width":"180px"},
        onChange: _cache[1] || (_cache[1] = (value) => {_ctx.printerTemp = value;_ctx.onSelcetChange();})
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.printTempOptions, (country, index) => {
            return (_openBlock(), _createBlock(_component_a_select_option, {
              key: index,
              title: country.label,
              value: country.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(country.label), 1)
              ]),
              _: 2
            }, 1032, ["title", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_oio_button, {
        class: "printbtn ant-btn-primary",
        onClick: _ctx.onPrintf
      }, {
        default: _withCtx(() => [
          _createTextVNode("打印")
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}